<template>
  <Notifications
    id="notifications-container"
    position="top right"
    width="400"
    class="pointer-events-none"
  >
    <template #body="{ item, close }">
      <div class="px-1">
        <div
          class="pointer-events-auto! mb-2 rounded-xl p-4 shadow"
          :class="types[item.type].container"
        >
          <div class="flex items-center space-x-4">
            <div class="shrink-0">
              <component
                :is="types[item.type].icon"
                :class="[types[item.type].iconColor, types[item.type].iconSize]"
              />
            </div>
            <div class="grow">
              <p class="text-sm" :class="[types[item.type].textColor]">
                {{ item.text }}
              </p>
            </div>
            <div class="flex shrink-0">
              <button
                @click="close"
                class="-m-2 inline-flex rounded-full p-2 text-neutral-500 hover:text-neutral-600 focus-visible:ring-2 focus-visible:ring-neutral-200 focus-visible:outline-none"
              >
                <span class="sr-only">Close</span>
                <CloseIcon class="h-[14px] w-[14px]" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Notifications>
</template>

<script setup>
import CheckIcon from '~icons/lucide/circle-check'
import InfoIcon from '~icons/lucide/info'
import CloseIcon from '~icons/lucide/x'
import { useNotificationsContainerPosition } from '@/shared/composables/useNotificationsContainerPosition'

useNotificationsContainerPosition('notifications-container')

const types = {
  success: {
    container: 'bg-white',
    icon: CheckIcon,
    iconSize: 'w-5 h-5',
    iconColor: 'text-success-500',
    textColor: 'text-success-500',
  },
  error: {
    container: 'bg-white',
    icon: InfoIcon,
    iconSize: 'w-5 h-5',
    iconColor: 'text-error-500',
    textColor: 'text-error-500',
  },
}
</script>

<style>
@reference "#tailwind-theme";

.vue-notification-group {
  @apply !z-[999];
}
#notifications-container span > *:first-child {
  @apply -mt-6;
}
#notifications-container span > *:not(:first-child) {
  @apply -mt-16;
}
</style>
